/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import React, { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { Collapse } from '@mui/material';
import { Badge, ExpandLessIcon, ExpandMoreIcon, Item, Title } from './style';
//
const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref}>
    <NavLink {...props} />
  </div>
));
/**
 * Side bar navigation list item is defined here
 * @param {*} props
 * @returns
 */
const SidebarNavListItem = (props) => {
  const { title, href, depth = 0, children, icon: Icon, badge, open: openProp = false } = props;
  //
  const [open, setOpen] = React.useState(openProp);
  //
  const handleToggle = () => {
    setOpen((state) => !state);
  };
  //
  if (children) {
    return (
      <>
        <Item depth={depth} onClick={handleToggle}>
          {Icon && <Icon />}
          <Title depth={depth}>
            {title}
            {badge && <Badge label={badge} />}
          </Title>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Item>
        <Collapse in={open}>{children}</Collapse>
      </>
    );
  }
  //
  return (
    <Item depth={depth} component={CustomRouterLink} to={href} activeClassname="active">
      {Icon && <Icon />}
      <Title depth={depth}>
        {title}
        {badge && <Badge label={badge} />}
      </Title>
    </Item>
  );
};
//
export default SidebarNavListItem;
